import { EmptyState } from "src/components/EmptyState/EmptyState"
import { langKeys } from "src/i18n/langKeys"
import { useTranslate } from "src/i18n/useTranslate"
import ApartmentIcon from "src/ui/icons/apartment-building.svg"

export function NoHomesOnFilter() {
  const { t } = useTranslate()

  return (
    <EmptyState
      icon={<ApartmentIcon />}
      title={t(langKeys.search_nothing_found)}
    />
  )
}
